export enum CurriculumTypeEnum  {
  TEMPLATE=1,
  USER_DEFINED=2,
}